/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * 
 * @export
 * @interface ShippingMethodReturnModel
 */
export interface ShippingMethodReturnModel {
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodReturnModel
     */
    sortOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodReturnModel
     */
    productReference?: string;
    /**
     * 
     * @type {Price}
     * @memberof ShippingMethodReturnModel
     */
    price?: Price;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodReturnModel
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodReturnModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodReturnModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodReturnModel
     */
    pickupPointProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodReturnModel
     */
    shippingMethodType?: string;
}

/**
 * Check if a given object implements the ShippingMethodReturnModel interface.
 */
export function instanceOfShippingMethodReturnModel(value: object): boolean {
    return true;
}

export function ShippingMethodReturnModelFromJSON(json: any): ShippingMethodReturnModel {
    return ShippingMethodReturnModelFromJSONTyped(json, false);
}

export function ShippingMethodReturnModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingMethodReturnModel {
    if (json == null) {
        return json;
    }
    return {
        
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'productReference': json['productReference'] == null ? undefined : json['productReference'],
        'price': json['price'] == null ? undefined : PriceFromJSON(json['price']),
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'] == null ? undefined : json['name'],
        'id': json['id'] == null ? undefined : json['id'],
        'pickupPointProvider': json['pickupPointProvider'] == null ? undefined : json['pickupPointProvider'],
        'shippingMethodType': json['shippingMethodType'] == null ? undefined : json['shippingMethodType'],
    };
}

export function ShippingMethodReturnModelToJSON(value?: ShippingMethodReturnModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sortOrder': value['sortOrder'],
        'productReference': value['productReference'],
        'price': PriceToJSON(value['price']),
        'description': value['description'],
        'name': value['name'],
        'id': value['id'],
        'pickupPointProvider': value['pickupPointProvider'],
        'shippingMethodType': value['shippingMethodType'],
    };
}

